import { Field, Float, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { Cache } from './Cache'

@ObjectType()
export class CacheStorage extends Cache {
  @Field(() => String)
  @Prop({ type: String })
  uri: string

  @Field(() => String)
  @Prop({ type: String })
  description: string

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date

  @Field(() => [String])
  @Prop({ type: [String] })
  directoryTree: string[]

  @Field(() => Float)
  @Prop({ type: Number })
  size: number
}
